module.exports = __webpack_public_path__ + "static/img/title.b90c685.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/title.png
// module id = dqPW
// module chunks = 0